/* MANSHURAT LUXE — Theme JS */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupDrawers();
    setupSearchLive();
    setupFiltersPanel();
    setupAddToCart();
    setupBuyNow();
    setupCheckoutForm();
    setupNotifyForm();
    setupReviewForm();
    setupHeaderScroll();
  }

  /* ========== DRAWERS (mobile menu, overlays) ========== */
  function setupDrawers() {
    const overlay = document.querySelector('[data-drawer-overlay]');
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileDrawer = document.querySelector('[data-mobile-drawer]');

    function closeMenu() {
      if (mobileDrawer) mobileDrawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-active');
      if (menuToggle) menuToggle.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    function close() {
      document.querySelectorAll('.is-open, .is-active').forEach(el => {
        el.classList.remove('is-open');
        el.classList.remove('is-active');
      });
      document.body.style.overflow = '';
    }

    if (menuToggle && mobileDrawer) {
      menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = mobileDrawer.classList.contains('is-open');
        if (isOpen) {
          // Si déjà ouvert -> fermer
          closeMenu();
        } else {
          // Sinon -> ouvrir
          mobileDrawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-active');
          menuToggle.classList.add('is-active');
          // Ne pas bloquer le body scroll sur mobile menu (le drawer scroll lui-même)
        }
      });
    }

    document.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', close));
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

    // Fermer le menu quand on clique sur un lien de navigation
    if (mobileDrawer) {
      mobileDrawer.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
          closeMenu();
        });
      });
    }

    // ===== Mobile submenu toggles (المواضيع → catégories) =====
    document.querySelectorAll('[data-mobile-sub-toggle]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const parent = btn.closest('.mobile-drawer__has-sub');
        if (!parent) return;
        const isOpen = parent.classList.contains('is-expanded');
        parent.classList.toggle('is-expanded', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  /* ========== LIVE SEARCH (predictive results) ========== */
  function setupSearchLive() {
    const trigger = document.querySelector('[data-search-trigger]');
    const overlay = document.querySelector('[data-search-overlay]');
    const closeBtn = document.querySelector('[data-search-close]');
    const input = document.querySelector('[data-search-input]');
    const resultsEl = document.querySelector('[data-search-results]');
    const clearBtn = document.querySelector('[data-search-clear]');

    if (!trigger || !overlay || !input) return;

    function openSearch() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input.focus(), 100);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function clearSearch() {
      input.value = '';
      if (clearBtn) clearBtn.style.display = 'none';
      resultsEl.innerHTML = '';
      resultsEl.classList.remove('has-results', 'is-active');
      input.focus();
    }

    trigger.addEventListener('click', e => {
      e.preventDefault();
      openSearch();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    if (clearBtn) clearBtn.addEventListener('click', clearSearch);

    // Click sur l'overlay (dehors de la barre) ferme aussi
    overlay.addEventListener('click', e => {
      if (e.target === overlay) closeSearch();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeSearch();
      }
    });

    let timer;
    input.addEventListener('input', e => {
      clearTimeout(timer);
      const q = e.target.value.trim();

      // Toggle clear button
      if (clearBtn) clearBtn.style.display = q.length > 0 ? 'grid' : 'none';

      if (q.length < 2) {
        resultsEl.innerHTML = '';
        resultsEl.classList.remove('has-results', 'is-active');
        return;
      }

      timer = setTimeout(() => doSearch(q, resultsEl), 200);
    });
  }

  async function doSearch(query, resultsEl) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
      const res = await fetch(url);
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (products.length === 0) {
        resultsEl.innerHTML = '<div class="search-no-results">لا توجد نتائج لـ "' + escapeHTML(query) + '"</div>';
        resultsEl.classList.add('is-active');
        resultsEl.classList.remove('has-results');
        return;
      }

      const header = '<div class="search-results__header">PRODUCTS</div>';
      const items = products.map(p => {
        const title = escapeHTML(p.title);
        const img = p.featured_image && p.featured_image.url
          ? `<img src="${p.featured_image.url}" alt="${title}" loading="lazy" onerror="this.outerHTML='<div class=&quot;search-result-card__placeholder&quot;></div>'">`
          : `<div class="search-result-card__placeholder"></div>`;
        return `
          <a href="${p.url}" class="search-result-card">
            ${img}
            <div class="search-result-card__info">
              <h4 class="search-result-card__title">${title}</h4>
            </div>
          </a>
        `;
      }).join('');

      const viewAllUrl = `/search?type=product&q=${encodeURIComponent(query)}`;
      const viewAll = `
        <a href="${viewAllUrl}" class="search-results__view-all">
          عرض جميع النتائج
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
        </a>
      `;

      resultsEl.innerHTML = header + items + viewAll;
      resultsEl.classList.add('has-results');
      resultsEl.classList.remove('is-active');
    } catch (err) {
      resultsEl.innerHTML = '<div class="search-no-results">حدث خطأ في البحث</div>';
      resultsEl.classList.add('is-active');
    }
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  /* ========== FILTERS PANEL (collection page) ========== */
  function setupFiltersPanel() {
    const toggle = document.querySelector('[data-filters-toggle]');
    const panel = document.querySelector('[data-filters-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.querySelectorAll('[data-filter-group-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.parentElement.classList.toggle('is-collapsed');
      });
    });

    // Auto-submit : quand on clique sur un radio de tri, la page se rafraichit
    const form = document.querySelector('[data-filters-form]');
    if (form) {
      form.querySelectorAll('input[data-auto-submit]').forEach(input => {
        input.addEventListener('change', () => {
          form.submit();
        });
      });
    }
  }

  /* ========== ADD TO CART (AJAX) + Open Cart Drawer ========== */
  function setupAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;

        const original = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json' }
          });
          if (res.ok) {
            btn.innerHTML = '✓ تمت الإضافة';
            await refreshCartDrawer();
            openCartDrawer(true);
            setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1800);
          } else {
            btn.innerHTML = original;
            btn.disabled = false;
          }
        } catch (err) {
          btn.innerHTML = original;
          btn.disabled = false;
        }
      });
    });

    // Cart icon click -> va directement vers la page panier (pas de drawer)
    // Le drawer s'ouvre uniquement après l'ajout d'un produit
    // (le lien <a> fait son travail naturellement, pas d'interception JS)

    // Close button
    document.querySelectorAll('[data-cart-close]').forEach(b => {
      b.addEventListener('click', closeCartDrawer);
    });

    const overlay = document.querySelector('[data-cart-overlay]');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  function openCartDrawer(showSuccess) {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    const success = document.querySelector('[data-cart-success]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    if (success) {
      success.style.display = showSuccess ? 'flex' : 'none';
      if (showSuccess) {
        setTimeout(() => { success.style.display = 'none'; }, 4000);
      }
    }
  }

  function closeCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCartDrawer(cart);
      updateCartCountFromCart(cart);
    } catch(e) {}
  }

  function updateCartCountFromCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2) + ' د.م';
  }

  function renderCartDrawer(cart) {
    const body = document.querySelector('[data-cart-drawer-body]');
    const footer = document.querySelector('[data-cart-drawer-footer]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
          <p>سلتك فارغة حالياً</p>
          <a href="/collections/all" class="btn btn--primary"><span>تصفّح المتجر</span></a>
        </div>
      `;
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = 'block';

    body.innerHTML = cart.items.map(item => {
      const img = item.image
        ? `<img class="cart-drawer__item-img" src="${item.image}" alt="${escapeHTML(item.product_title)}">`
        : `<div class="cart-drawer__item-placeholder"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M2 3h7a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-7a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h8z"/></svg></div>`;

      return `
        <div class="cart-drawer__item" data-line-key="${item.key}">
          ${img}
          <div class="cart-drawer__item-info">
            ${item.vendor ? `<div class="cart-drawer__item-vendor">${escapeHTML(item.vendor)}</div>` : ''}
            <a href="${item.url}" class="cart-drawer__item-title">${escapeHTML(item.product_title)}</a>
            <div class="cart-drawer__item-meta">
              <div class="cart-drawer__qty">
                <button type="button" data-qty-decrease aria-label="نقص">−</button>
                <input type="number" value="${item.quantity}" min="1" data-qty-input>
                <button type="button" data-qty-increase aria-label="زيادة">+</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-remove>إزالة</button>
            </div>
          </div>
          <div class="cart-drawer__item-price">${formatMoney(item.line_price)}</div>
        </div>
      `;
    }).join('');

    // Update total
    const totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Update inline count in "voir mon panier" button
    const inlineCount = document.querySelector('[data-cart-count-inline]');
    if (inlineCount) inlineCount.textContent = cart.item_count;

    // Bind quantity buttons
    body.querySelectorAll('.cart-drawer__item').forEach(itemEl => {
      const key = itemEl.dataset.lineKey;
      const qtyInput = itemEl.querySelector('[data-qty-input]');

      itemEl.querySelector('[data-qty-decrease]').addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10);
        if (v > 1) updateLine(key, v - 1);
      });
      itemEl.querySelector('[data-qty-increase]').addEventListener('click', () => {
        const v = parseInt(qtyInput.value, 10);
        updateLine(key, v + 1);
      });
      qtyInput.addEventListener('change', () => {
        const v = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        updateLine(key, v);
      });
      itemEl.querySelector('[data-remove]').addEventListener('click', () => {
        updateLine(key, 0);
      });
    });
  }

  async function updateLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (res.ok) {
        const cart = await res.json();
        renderCartDrawer(cart);
        updateCartCountFromCart(cart);
      }
    } catch(e) {}
  }

  // Initial render on page load
  refreshCartDrawer();

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartCountFromCart(cart);
    } catch(e) {}
  }

  /* ========== CHECKOUT FORM (custom) ========== */
  function setupCheckoutForm() {
    const form = document.querySelector('[data-checkout-form]');
    if (!form) return;

    // Phone validation: 10 digits only (e.g., 0600000000)
    const phoneInput = form.querySelector('[name="phone"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', e => {
        let v = e.target.value.replace(/\D/g, '');
        if (v.length > 10) v = v.substring(0, 10);
        e.target.value = v;
      });
    }

    // Standard checkout button
    const checkoutBtn = form.querySelector('[data-checkout-btn]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', async e => {
        e.preventDefault();
        if (!validateForm(form)) return;

        // Save customer info as cart attributes/note then redirect
        const fd = new FormData(form);
        const note = buildOrderNote(fd);
        const attrs = {
          'attributes[الاسم]': fd.get('full_name') || '',
          'attributes[الهاتف]': fd.get('phone') || '',
          'attributes[العنوان]': fd.get('address') || '',
          'attributes[المدينة]': fd.get('city') || '',
          note: note
        };
        const params = new URLSearchParams(attrs);

        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
          });
          window.location.href = '/checkout';
        } catch (err) {
          window.location.href = '/checkout';
        }
      });
    }

    // WhatsApp button
    const whatsappBtn = form.querySelector('[data-whatsapp-btn]');
    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', async e => {
        e.preventDefault();
        if (!validateForm(form)) return;

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          const fd = new FormData(form);
          const phoneNumber = whatsappBtn.dataset.whatsappNumber || '';
          const message = buildWhatsAppMessage(fd, cart);

          const cleanNumber = phoneNumber.replace(/\D/g, '');
          const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
          window.open(url, '_blank');
        } catch (err) {
          alert('حدث خطأ. يرجى المحاولة مرة أخرى.');
        }
      });
    }
  }

  function validateForm(form) {
    let valid = true;
    const required = form.querySelectorAll('[required]');
    required.forEach(field => {
      const errorEl = field.parentElement.querySelector('.field-error');
      if (errorEl) errorEl.remove();

      if (!field.value.trim()) {
        showFieldError(field, 'هذا الحقل مطلوب');
        valid = false;
      }
    });

    const phone = form.querySelector('[name="phone"]');
    if (phone && phone.value && !/^0[0-9]{9}$/.test(phone.value)) {
      showFieldError(phone, 'رقم الهاتف يجب أن يكون 10 أرقام (مثال: 0600000000)');
      valid = false;
    }

    if (!valid) {
      const firstError = form.querySelector('.field-error');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  }

  function showFieldError(field, msg) {
    const error = document.createElement('div');
    error.className = 'field-error';
    error.textContent = msg;
    error.style.cssText = 'color:#c84545;font-size:0.85rem;margin-top:0.3rem;';
    field.parentElement.appendChild(error);
    field.style.borderColor = '#c84545';
    field.addEventListener('input', () => {
      error.remove();
      field.style.borderColor = '';
    }, { once: true });
  }

  function buildOrderNote(fd) {
    return `طلب جديد:
الاسم: ${fd.get('full_name') || ''}
الهاتف: ${fd.get('phone') || ''}
العنوان: ${fd.get('address') || ''}
المدينة: ${fd.get('city') || ''}
ملاحظات: ${fd.get('order_note') || 'لا توجد'}`;
  }

  function buildWhatsAppMessage(fd, cart) {
    const fullName = fd.get('full_name') || '';
    const phone = fd.get('phone') || '';
    const address = fd.get('address') || '';
    const city = fd.get('city') || '';
    const note = fd.get('order_note') || '';

    let msg = '🌙 *طلب جديد من منشورات الفكر*\n\n';
    msg += '👤 *معلومات العميل:*\n';
    msg += `الاسم: ${fullName}\n`;
    msg += `الهاتف: ${phone}\n`;
    msg += `العنوان: ${address}\n`;
    msg += `المدينة: ${city}\n`;
    if (note) msg += `ملاحظات: ${note}\n`;
    msg += '\n📚 *تفاصيل الطلب:*\n';
    msg += '─────────────\n';

    cart.items.forEach((item, i) => {
      const price = (item.price / 100).toFixed(2);
      const lineTotal = (item.line_price / 100).toFixed(2);
      msg += `\n${i + 1}. *${item.product_title}*\n`;
      if (item.variant_title && item.variant_title !== 'Default Title') {
        msg += `   ${item.variant_title}\n`;
      }
      msg += `   الكمية: ${item.quantity}\n`;
      msg += `   السعر: ${price} درهم\n`;
      msg += `   المجموع: ${lineTotal} درهم\n`;
    });

    msg += '\n─────────────\n';
    msg += `\n💰 *المجموع الكلي: ${(cart.total_price / 100).toFixed(2)} درهم*\n`;
    msg += `📦 عدد القطع: ${cart.item_count}\n\n`;
    msg += '✅ يرجى تأكيد الطلب. شكراً لكم! 🌹';

    return msg;
  }

  /* ========== NOTIFY ME (out of stock) ========== */
  function setupNotifyForm() {
    document.querySelectorAll('[data-notify-form]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const email = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button');
        if (email && email.value) {
          btn.textContent = '✓ سنخبركم عند توفّره';
          btn.disabled = true;
          email.disabled = true;
        }
      });
    });
  }

  /* ========== REVIEW FORM ========== */
  function setupReviewForm() {
    const form = document.querySelector('[data-review-form]');
    if (!form) return;

    const stars = form.querySelectorAll('.star-rating button');
    const ratingInput = form.querySelector('input[name="rating"]');

    stars.forEach((star, i) => {
      star.addEventListener('click', () => {
        const val = i + 1;
        if (ratingInput) ratingInput.value = val;
        stars.forEach((s, j) => {
          s.classList.toggle('active', j < val);
        });
      });
      star.addEventListener('mouseenter', () => {
        stars.forEach((s, j) => s.classList.toggle('hover', j <= i));
      });
      star.addEventListener('mouseleave', () => {
        stars.forEach(s => s.classList.remove('hover'));
      });
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn.textContent = '✓ شكراً، تمّ إرسال تقييمك';
      submitBtn.disabled = true;
    });
  }

  /* ========== BUY NOW (achat direct -> COD checkout) ========== */
  function setupBuyNow() {
    document.querySelectorAll('[data-buy-now]').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        const form = btn.closest('form');
        if (!form) return;

        const originalText = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
        const spanEl = btn.querySelector('span');
        if (spanEl) spanEl.textContent = '...';
        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json' }
          });
          if (res.ok) {
            // Redirection directe vers la page COD
            window.location.href = '/pages/cod-checkout';
          } else {
            if (spanEl) spanEl.textContent = originalText;
            btn.disabled = false;
            alert('حدث خطأ، الرجاء المحاولة مرة أخرى');
          }
        } catch (err) {
          if (spanEl) spanEl.textContent = originalText;
          btn.disabled = false;
          alert('حدث خطأ، الرجاء المحاولة مرة أخرى');
        }
      });
    });
  }

  /* ========== HEADER STICKY (approche Trade) ========== */
  function setupHeaderScroll() {
    const header = document.querySelector('.site-header');
    const stickyHeader = document.querySelector('sticky-header');
    if (!header) return;

    // Met à jour la variable CSS --header-height
    function setHeaderHeight() {
      const height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }

    setHeaderHeight();
    window.addEventListener('load', setHeaderHeight);
    window.addEventListener('resize', setHeaderHeight);

    // Si on n'a pas de sticky-header Web Component, fallback simple
    if (!stickyHeader) return;
  }

})();

/* ============================================
   STICKY HEADER simplifié - approche scroll direct
   Hide on scroll-down / Reveal on scroll-up
   ============================================ */
if (typeof customElements !== 'undefined' && !customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.site-header');
      if (!this.header) return;

      // Hauteur du header pour le spacer
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      window.addEventListener('load', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.threshold = 80; // px à scroller avant que ça réagisse
      this.ticking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      if (!this.header) return;
      const h = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Tout en haut : reset
      if (scrollTop <= this.threshold) {
        this.classList.remove('scrolled-past-header');
        this.currentScrollTop = scrollTop;
        return;
      }

      // On a scrollé : marquer (pour appliquer le style "scrolled")
      // Le header reste TOUJOURS visible (pas de hide)
      this.classList.add('scrolled-past-header');
      // S'assurer qu'il n'est jamais caché
      this.classList.remove('shopify-section-header-hidden');

      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);
}
